import { LANG, setLang } from "@shared/i18n";
import { cn } from "@/lib/utils";

/** Bascule FR / EN des pages publiques (une fois connecté, la langue suit le profil). */
export function LangToggle({ className }: { className?: string }) {
  const next = LANG === "fr" ? "en" : "fr";
  return (
    <button
      type="button"
      onClick={() => setLang(next)}
      className={cn("press flex h-10 min-w-10 items-center justify-center rounded-full px-2 text-[13px] font-semibold text-muted hover:bg-surface hover:text-fg", className)}
      aria-label={next === "en" ? "English version" : "Version française"}
      lang={next}
    >
      {next.toUpperCase()}
    </button>
  );
}
